import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import SubAgentTable from "../Components/SubAgent/SubAgentTable";
import SubAgentDialogBox from "../Components/SubAgent/SubAgentDialogBox";
import { Button } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import Scaffold from "../Components/Layout/Scaffold";

const SubAgent = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }


  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Sub Agents"
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxWidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-search"
            type="search"
            label="Search"
            variant="outlined"
            inputProps={{
              style: {
                width: "300px",
                fontSize: "14px",
              },
            }}
            size="small"
            placeholder="Enter search keyword"
            value={textInput}
            onChange={handleTextInputChange}
          />
        </Box>,
        <Button
          endIcon={<SearchOutlined />}
          className="mx-2"
          variant="contained"
          color="secondary"
          onClick={() => {
            changeFilters("keyword", "" + textInput);
          }}>
          Search
        </Button>
      ]}
      mainAction={<Button variant="contained"
        color="primary"
        onClick={() => {
          setEditDialogVisibility(true);
        }}
        startIcon={<AddIcon fontSize="small" />}
      >
        Create
      </Button>}
    >
      <>
      <SubAgentTable filter={filter} />
      <SubAgentDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={{}}
        dialogAction={EDialogAction.create}
      />
      </>
    </Scaffold>
  )

  return (
    <>
      <p className="text-2xl mb-3 ">Sub Agents</p>
      <div className="flex justify-between">
        <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxWidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-search"
              type="search"
              label="Search"
              variant="outlined"
              inputProps={{
                style: {
                  width: "300px",
                  fontSize: "14px",
                },
              }}
              size="small"
              placeholder="Enter search keyword"
              value={textInput}
              onChange={handleTextInputChange}
            />
          </Box>

          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
        </div>
        <Button variant="contained"
          color="primary"
          onClick={() => {
            setEditDialogVisibility(true);
          }}
          startIcon={<AddIcon fontSize="small" />}
        >
          Create
        </Button>
      </div>
      <SubAgentTable filter={filter} />
      <SubAgentDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={{}}
        dialogAction={EDialogAction.create}
      />
    </>
  );
};

export default SubAgent;
